angular.module('routes.endpoints.EndpointsController', [
  'stack',
  'services'
])

/**
 * The EndpointsController manages view logic rendered to the
 * endpoints.html template for the /endpoints endpoints.
 *
 * @class EndpointsController
 * @constructor
 * @module routes.endpoints.EndpointsController
 */
.controller('EndpointsController', [
  '$scope',
  '$state',
  'constants',
  'ModelsService',
  'EndpointsService',
  'MethodsService',
  'RelativesService',
  function (
    $scope,
    $state,
    constants,
    ModelsService,
    EndpointsService,
    MethodsService,
    RelativesService
  ) {
    'use strict';

    /**
     * Property houses controller namespace.
     *
     * @property endpoints
     * @type {Object}
     */
    $scope.endpoints = {
      constants: {},
      data: [],
      current: null, // current instance
      endpoint: null, // current endpoint
      contentCreate: null, // create new instance on endpoint
      contentEdit: null, // edit current instance
      methodsEdit: null,
      relativesEdit: null,
      mode: '',
      tab: '',
      tabs: {
        general: false,
        content: false,
        crud: false,
        methods: false,
        relatives: false
      },
      buttons: {
        newModel: true,
        getAllInstances: true,
        createNewInstance: true,
        deleteInstance: true,
        editMethods: true,
        editRelatives: true
      }
    };

    $scope.state = $state;

    console.log($state);

    $scope.states = null;

    /**
     * Resets the internal state of content
     */
    $scope.cleanStates = function cleanStates() {
      var state;
      var content;
      var item;
      var update = false;

      console.log('cleanStates');

      if (!$scope.states) {
        $scope.states = _.clone(ModelsService.read('states'));
      }

      if ($scope.states.length > 0) {
        state = $scope.states.pop();

        if (_.isObject(_.first(state.content.decisions))) {
          if (_.first(state.content.decisions).id) {
            state.content.decisions = [_.first(state.content.decisions).id];
          }
          update = true;
        }
        if (_.isObject(_.first(state.content.rules))) {
          if (_.first(state.content.rules).id) {
            state.content.rules = [_.first(state.content.rules).id];
          }
          update = true;
        }

        if (update) {
          console.log('update:', state.id);

          content = {
            content: state.content
          };

          item = ModelsService.find('states', 'id', state.id);

          ModelsService
            .update(item, content)
            .then(function (response) {
              console.log(response);
              return $scope.cleanStates();
            })
            .catch(function (response) {
              console.log(response);
            });
        } else {
          $scope.cleanStates();
        }
      }
    };

    /**
     * Calls private toggle method
     */
    $scope.toggleContentEdit = function toggleContentEdit() {
      toggleContentEdit();
    };

    /**
     * Saves relatives edit
     */
    $scope.saveRelativesEdit = function saveRelativesEdit() {
      RelativesService
        .saveRelativesEditData(
          $scope.endpoints.relativesEdit.model,
          $state.params.endpoint,
          $scope.endpoints.current
        )
        .then(function () {
          $state.go('routes.endpoints', { mode: '' });
          return;
        })
        .catch(function (response) {
          console.log(response);
        });
    };

    /**
     * Saves method edit
     */
    $scope.saveMethodsEdit = function saveMethodsEdit() {
      MethodsService
        .saveMethodsEditData(
          $scope.endpoints.methodsEdit.model,
          $state.params.endpoint,
          $scope.endpoints.current
        )
        .then(function () {
          $state.go('routes.endpoints', { mode: '' });
          return;
        })
        .catch(function (response) {
          console.log(response);
        });
    };

    /**
     * Saves content edit
     */
    $scope.saveContentEdit = function saveContentEdit() {
      EndpointsService
        .saveContentEditData(
          $scope.endpoints.contentEdit.model,
          $state.params.endpoint,
          $scope.endpoints.current
        )
        .then(function () {
          $state.go('routes.endpoints', { mode: '' });
          return;
        })
        .catch(function (response) {
          console.log(response);
        });
    };

    /**
     * Saves content create
     */
    $scope.saveContentCreate = function saveContentCreate() {
      if ($state.params.tab === 'content') {
        EndpointsService
          .saveContentCreateData($scope.endpoints.contentCreate.model, $state.params.endpoint)
          .then(function (response) {
            $state.go(
              'routes.endpoints',
              { id: response[response.primaryKey], mode: null, tab: null }
            );
            return;
          })
          .catch(function (response) {
            console.log(response);
          });
      }
    };

    /**
     * Deletes the current instance from
     * the model
     */
    $scope.deleteCurrentItem = function deleteCurrentItem() {
      ModelsService
        .remove($scope.endpoints.current)
        .then(function () {
          $state.go('routes.endpoints', { id: null, mode: null });
          return;
        })
        .catch(function (response) {
          console.log(response);
        });
    };

    /**
     * Method sets the current instance from the current endpoint model
     *
     * @private
     */
    function defineCurrentInstance() {
      $scope.endpoints.current = EndpointsService.getCurrentInstance($state.params.id);
      if ($state.params.tab === 'content' && $state.params.mode !== 'create') {
        $scope.endpoints.contentEdit = EndpointsService.getContentEdit();
      } else if ($state.params.tab === 'methods') {
        $scope.endpoints.methodsEdit = MethodsService.getMethodsEdit($state.params.endpoint);
      } else if ($state.params.tab === 'relatives') {
        $scope.endpoints.relativesEdit = RelativesService.getRelativesEdit($state.params.endpoint);
      }
      defineCrud();
    }

    /**
     * Method sets the current endpoint model
     *
     * @private
     */
    function defineEndpoint() {
      if (!$state.params.endpoint) {
        $state.go(
          'routes.endpoints',
          { endpoint: 'endpoints', id: 'endpoints', mode: null, tab: null }
        );
      } else {
        $scope.endpoints.endpoint = EndpointsService.getCurrentEndpoint($state.params.endpoint);
        if ($state.params.tab === 'content') {
          $scope.endpoints.contentCreate = EndpointsService
            .getContentCreate($state.params.endpoint);
        } else if ($state.params.tab === 'methods') {
          $scope.endpoints.methodsEdit = MethodsService.getMethodsEdit($state.params.endpoint);
        } else if ($state.params.tab === 'relatives') {
          $scope.endpoints.relativesEdit = RelativesService
            .getRelativesEdit($state.params.endpoint);
        }
      }
    }

    /**
     * Method sets endpoints data from Model
     *
     * @private
     */
    function defineData() {
      $scope.endpoints.data = EndpointsService.getEntriesFromEndpoint($state.params.endpoint);
    }

    /**
     * Method copies resolved constants into the controller
     * namespace during the initalization process.
     *
     * @private
     */
    function defineConstants() {
      var endpoints = $scope.endpoints;
      $scope.endpoints = angular.extend(endpoints, constants);
    }


    /**
     * Sets the available crud operations for the current state
     *
     * @private
     */
    function defineCrud() {
      var buttons = {};

      buttons.newModel = ModelsService.hasCrud('post', 'endpoints', $state.params.endpoint);
      if ($scope.endpoints.current) {
        buttons.getAllInstances = ModelsService.hasCrud(
          'getAll',
          $scope.endpoints.endpoint.label,
          $scope.endpoints.current[$scope.endpoints.current.primaryKey]
        );
        buttons.createInstance = ModelsService.hasCrud(
          'post',
          $scope.endpoints.endpoint.label,
          $scope.endpoints.current[$scope.endpoints.current.primaryKey]
        );
        buttons.deleteInstance = ModelsService.hasCrud(
          'delete',
          $scope.endpoints.endpoint.label,
          $scope.endpoints.current[$scope.endpoints.current.primaryKey]
        );
        buttons.editMethods = ModelsService.hasCrud(
          'put',
          $scope.endpoints.endpoint.label,
          $scope.endpoints.current[$scope.endpoints.current.primaryKey]
        );
        buttons.editRelatives = ModelsService.hasCrud(
          'put',
          $scope.endpoints.endpoint.label,
          $scope.endpoints.current[$scope.endpoints.current.primaryKey]
        );
      }

      $scope.endpoints.buttons = buttons;
    }

    /**
     * Sets $scope from $state.params
     *
     * @private
     */
    function defineState() {
      $scope.endpoints.mode = $state.params.mode;
      $scope.endpoints.tab = $state.params.tab;

      $scope.endpoints.tabs = {
        general: $state.params.tab === 'general' || false,
        content: $state.params.tab === 'content' || false,
        crud: $state.params.tab === 'crud' || false,
        methods: $state.params.tab === 'methods' || false,
        relatives: $state.params.tab === 'relatives' || false
      };
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      defineConstants();
      defineData();
      defineEndpoint();
      defineCurrentInstance();
      defineState();
    }
    initialize();
  }
]);
